export const accountChangeLogColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'createdAt',
    label: 'Operation Date',
  },
  {
    name: 'type',
    label: 'Type Of Operation',
  },
  {
    name: 'value',
    label: 'Operation Value',
  },
];

export const acountChangeLogDefaultSorter = {};

export const accountChangeLogSchema = {};
